<template>
    <div class="form-container" dir="rtl">
        <div class="loading" v-if="loading"></div>
        <img src="../../public/img/icons/apple-touch-icon-120x120.png" alt="Logo" class="logo" />
        <h3 class="title">Expert</h3>
        <h3 class="subtitle">ByteCraft</h3>
        <h1 class="form-title">{{ userName }} خوش آمدید!</h1>
        <p class="form-description">با تشکر از همراهی شما. لطفا نظرات و پیشنهادات خود را با ما در میان بگذارید.</p>
        <p class="form-description">ما به نظرات شما اهمیت می‌دهیم و از آن‌ها برای بهبود خدمات خود استفاده می‌کنیم.</p>
        <br />
        <p class="form-description">هرگونه سوال، نظر، پیشنهاد و یا مشکل در این پلتفرم را با ما در میان بگذارید.</p>
        <form @submit.prevent="handleSubmit" class="question-form">
            <div class="form-group">
                <label for="acquainted">از چه طریق با این پلتفرم آشنا شده اید؟</label>
                <select id="acquainted" v-model="formData.acquainted" required>
                    <option value="friend">معرفی دوستان</option>
                    <option value="social_media">شبکه‌های اجتماعی</option>
                    <option value="search_engine">گوگل و موتورهای جستجو</option>
                    <option value="bazar">جستجو در کافه بازار</option>
                    <option value="other">سایر</option>
                </select>
            </div>
            <div class="form-group">
                <label for="Strength">چه بخشی در این پلتفرم برای شما جذاب بوده است؟</label>
                <select id="Strength" v-model="formData.Strength" required>
                    <option value="user_interface">رابط کاربری</option>
                    <option value="new_idea">ایده جدید بودن</option>
                    <option value="performance">عملکرد</option>
                    <option value="other">سایر</option>
                </select>
            </div>
            <div class="form-group">
                <label for="suggestion">چقدر اشتیاق در معرفی این پلتفرم به دوستان خود دارید؟</label>
                <p class="request-description">افزایش تعداد کاربران باعث رشد پلتفرم و بیشتر دیده شدن اعضا و همینطور
                    روحیه تیم برای ارتقا پلتفرم خواهد شد.</p>
                <select id="suggestion" v-model="formData.suggestion" required>
                    <option value="sure">حتما معرفی میکنم</option>
                    <option value="maybe">ممکن است معرفی کنم</option>
                    <option value="never">معرفی نمیکنم</option>
                </select>
            </div>
            <div class="form-group">
                <label for="feedback">نظر خود را برای بهبود عملکرد ما بنویسید:</label>
                <textarea id="feedback" v-model="formData.feedback"
                    placeholder="چه تغییراتی در نسخه بعدی که به زودی منتشر خواهد شد اعمال شود؟" rows="7"
                    required></textarea>
            </div>
            <button type="submit" class="submit-button">ارسال</button>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    mounted() {
        this.userName = this.$route.params.userId + ' عزیز';
    },
    data() {
        return {
            formData: {
                acquainted: '',
                Strength: '',
                feedback: '',
                suggestion: '',
            },
            userName: null,
            loading: false,
        };
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            let from = new FormData();
            from.append('acquainted', this.formData.acquainted);
            from.append('Strength', this.formData.Strength);
            from.append('feedback', this.formData.feedback);
            from.append('suggestion', this.formData.suggestion);
            from.append('userName', this.$route.params.userId);
            let response = await axios.post('https://bytecraft.ir/expert/api/get_feedback', from);
            if (response.status === 200) {
                this.$notifications.notify(
                    {
                        message: `<span style="color: #222; width: 100%;">,ارسال با موفقیت انجام شد. با تشکر از همکاری شما..</span>`,
                        icon: 'nc-icon nc-notification-70',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'success',
                    })
            } else {
                alert('Failed to submit feedback. Please try again later.');
            }
            this.formData = { name: '', email: '', feedback: '' };
            this.loading = false;
            setTimeout(() => {
                this.$router.push({ name: 'blog' });
            }, 2000);
        },
    },
};
</script>

<style scoped lang="scss">
.alert {
    position: absolute !important;
    top: 10px !important;
    width: 100% !important;
    margin: 0 auto !important;
}

.form-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background-color: #eeffe6;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;

    img {
        width: 150px;
        height: 150px;
    }

    .title {
        margin-top: -10px;
        margin-bottom: 0px;
        font-size: 24px;
        color: #32794d;
    }

    .subtitle {
        font-size: 20px;
        font-weight: 200;
        color: #297433b6;
        margin-top: 0;
    }

    form {
        margin-top: 50px;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        text-align: right;

        label {
            margin-bottom: 5px;
            font-size: 14px;
            color: #333;
        }

        select,
        textarea {
            padding: 5px;
            border: 1px solid #ccc;
            border-radius: 8px;
            font-size: 14px;
            color: #333;
            background-color: #fff;
        }

        textarea {
            resize: none;
        }

        .request-description {
            font-size: 12px;
            color: #555;
            margin-bottom: 5px;
        }
    }

    .submit-button {
        padding: 10px 20px;
        background-color: #007bff;
        color: #fff;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-size: 16px;
        transition: background-color 0.3s ease;

        &:hover {
            background-color: #0056b3;
        }
    }

    .form-title {
        font-size: 24px;
        margin-bottom: 30px;
        color: #333;
    }

    .form-description {
        font-size: 14px;
        width: 75%;
        margin: 0 auto;
        color: #2c2c2c;
    }

    .form-description span {
        font-weight: bold;
    }
}

.loading {
    display: block;
    position: fixed;
    width: 150px;
    height: 150px;
    border: 16px solid #f3f3f3;
    border-top: 16px solid #3498db;
    border-radius: 50%;
    animation: spin 2s linear infinite;
    margin: 0 auto;
    margin-top: 20px;
    align-self: anchor-center;
    justify-self: anchor-center;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}
</style>